<template>
  <div>
    <p>
      Para criar um novo campo de formulário, escolha o tipo de campo e
      configure suas opções.
    </p>

    <form @submit.prevent="submit()" class="row mt-4">
      <div class="col-md-4">
        <span><strong>Clique no item para adicionar:</strong></span>
        <div class="row">
          <div class="col-md-12 mt-3">
            <v-chip
              v-for="opcao in (listaCamposEdicoes ? listaCamposEdicoes : options)"
              :key="opcao.value"
              @click="handleTipoCampo(opcao)"
              :outlined="tipo_campo.value !== opcao.value"
              :color="tipo_campo.value === opcao.value ? 'primary' : 'grey'"
              class="ma-1 d-block mb-2"
              style="height: auto; padding: 12px 16px;"
            >
              <v-icon left>{{ opcao.icon }}</v-icon>
              {{ opcao.label }}
            </v-chip>
          </div>
        </div>
      </div>

     
      <div class="col-md-8" style="border-left: solid 1px #ccc">
        <h4 class="mb-3">{{ tipo_campo ? tipo_campo.label : "" }}</h4>
        <div class="row">
          <div class="col-md-6">
            <SGPFormInputComponent
              type="text"
              name="label"
              v-model="formulario.label"
              placeholder="Rótulo do campo (Label)"
              placeholderText="Label"
              data-vv-as="Rótulo do campo (Label)"
              v-validate="'required|min:2'"
              :error="validationErrors.first('label')"
              :disabled="formulario.tipo_campo ? false : true"
              stylized
              solo
            />
          </div>

          <div class="col-md-6">
            <SGPFormInputComponent
              type="text"
              name="name"
              v-model="formulario.name"
              placeholder="Nome do campo (name)"
              placeholderText="Name"
              data-vv-as="Nome do campo (name)"
              v-validate="'required|min:2'"
              :error="validationErrors.first('name')"
              :disabled="formulario.tipo_campo ? false : true"
              stylized
              solo
            />
          </div>

          <div class="col-6">
            <SGPFormInputComponent
              type="text"
              name="placeholder"
              v-model="formulario.placeholder"
              placeholder="Placeholder"
              placeholderText="Placeholder"
              data-vv-as="Placeholder"
              v-validate="'min:2'"
              :error="validationErrors.first('placeholder')"
              :disabled="formulario.tipo_campo ? false : true"
              stylized
              solo
            />
          </div>

          <div class="col-6">
            <SGPFormInputComponent
              type="text"
              name="desc_ajuda"
              v-model="formulario.desc_ajuda"
              placeholder="Descrição de ajuda"
              placeholderText="Descrição"
              data-vv-as="Descrição de ajuda"
              v-validate="'min:2'"
              :error="validationErrors.first('desc_ajuda')"
              :disabled="formulario.tipo_campo ? false : true"
              class=""
              stylized
              solo
            />
          </div>

          <div
            class="col-12"
            v-if="possuiValorPadrao.includes(formulario.tipo_campo)"
          >
            <SGPFormInputComponent
              :type="formulario.tipo_campo"
              name="valor_padrao"
              v-model="formulario.valor_padrao"
              placeholder="Valor padrão"
              placeholderText="Valor padrão"
              data-vv-as="Valor padrão"
              :error="validationErrors.first('valor_padrao')"
              :disabled="formulario.tipo_campo ? false : true"
              class=""
              stylized
              solo
            />
          </div>

          <div
            class="col-6"
            v-if="camposTipoData.includes(formulario.tipo_campo)"
          >
            <SGPFormCheckboxComponent
              name="valor_padrao"
              v-model="formulario.data_corrente"
              placeholder="Mostrar data atual"
              label="Mostrar data atual"
              data-vv-as="Mostrar data atual"
              :error="validationErrors.first('data_corrente')"
              class=""
              stylized
              solo
            />
          </div>

          <div class="col-12" v-if="formulario.tipo_campo">
            <SGPFormSelectComponent
              titulo="Indíce Ficha Técnica"
              :type="formulario.ctrl_indice_ficha_tecnica_id"
              name="ctrl_indice_ficha_tecnica_id"
              :listaDeOptions="listaDeIndicesFichasTecnicas"
              optionLabel="label"
              v-model="formulario.ctrl_indice_ficha_tecnica_id"
              placeholder="Indidice Ficha Tecnica"
              placeholderText="Indíce Ficha Técnica"
              :disabled="formulario.tipo_campo ? false : true"
              class=""
              stylized
              mostrarSelecione
              solo
            />
          </div>

          <div
            class="col-6"
            v-if="['text', 'textarea', 'number'].includes(formulario.tipo_campo)"
          >
            <v-chip
              @click="limite_caractere = !limite_caractere"
              :outlined="!limite_caractere"
              class="d-block"
              pill
              :color="`${
                limite_caractere ? 'primary lighten-1' : 'primary lighten-1'
              }`"
            >
              <v-icon left> mdi-sort-numeric-variant </v-icon>
              Definir limite de caracteres
            </v-chip>

            <div class="row mt-3" v-if="limite_caractere">
              <div class="col-6" v-if="limite_caractere">
                <SGPFormInputComponent
                  type="number"
                  name="min"
                  v-model="formulario.min"
                  placeholder="Min"
                  placeholderText="Min"
                  class=""
                  stylized
                  solo
                />
              </div>
              <div class="col-6" v-if="limite_caractere">
                <SGPFormInputComponent
                  type="number"
                  name="max"
                  v-model="formulario.max"
                  placeholder="Max"
                  placeholderText="Max"
                  class=""
                  stylized
                  solo
                />
              </div>
            </div>
          </div>

          <div class="col-3" v-if="formulario.tipo_campo == 'select'">
            <SGPFormCheckboxComponent
              name="multiselect"
              v-model="formulario.multiselect"
              label="Seleção multipla"
              class=""
              stylized
              solo
              v-if="false"
            />
          </div>

          <div
            class="col-6"
            v-if="
              ['text', 'number', 'textarea'].includes(formulario.tipo_campo)
            "
          >
            <v-chip
              @click="formulario.campo_oculto = !formulario.campo_oculto"
              :class="`d-block`"
              :outlined="!formulario.campo_oculto"
              pill
              color="black"
            >
              <v-icon left>
                {{
                  formulario.campo_oculto
                    ? "mdi-radiobox-marked"
                    : "mdi-checkbox-blank-circle-outline"
                }}
              </v-icon>
              {{
                !formulario.campo_oculto
                  ? "Definir campo como oculto"
                  : "Campo definido como oculto"
              }}
            </v-chip>
          </div>

          <div class="col-12" v-if="formulario.tipo_campo == 'text'">
            <div class="grey lighten-4 pa-3" style="border-radius: 8px;">
              <p class="h6">Máscaras</p>

              <v-chip
                v-for="mascara in mascaras"
                :key="mascara"
                @click="setarMascara(mascara.value)"
                outlined
                class="mr-2 mb-3"
                pill
                color="purple lighten-2"
              >
                {{ mascara.label }}
              </v-chip>

              <div class="row">
                <SGPFormInputComponent
                  name="mascara"
                  v-model="formulario.mascara"
                  class="col-6"
                  stylized
                  solo
                />
                <SGPFormInputComponent
                  name="mascara"
                  class="col-6"
                  stylized
                  solo
                  v-mask="formulario.mascara"
                  placeholderText="Teste sua máscara"
                />
              </div>
              <small>
                Use # para números, A para letras e X para número ou letras<br>
                Ex: AAAXX## permite algo como BRA2E19 (placa mercosul)
              </small>
            </div>
          </div>
        </div>

        <RequisicaoCampoComponent
          v-if="formulario.tipo_campo == 'requisicao' && formulario.tipo_campo != 'text'"
          :formulario="formulario"
        />

        <div
          :class="`col-12 mt-5 ${classeOpcoes}`"
          style="background-color: #f4f4f4; border-radius: 6px"
          v-if="['select', 'select-agrupado', 'radio', 'checkbox'].includes(formulario.tipo_campo)"
        >
          <h6>Adicionar opções</h6>
          <v-radio-group v-model="formulario.valor_padrao">
            <div
              class="row align-items-center"
              v-for="(opcao, index) in formulario.opcoes"
              :key="opcao.value"
            >
              <div :class="formulario.tipo_campo === 'select-agrupado' ? 'col-4' : 'col-5'">
                <SGPFormInputComponent
                  type="text"
                  name="label"
                  v-model="opcao.label"
                  placeholder="Label"
                  placeholderText="Label"
                  stylized
                  solo
                />
              </div>
              <div :class="formulario.tipo_campo === 'select-agrupado' ? 'col-4' : 'col-5'">
                <SGPFormInputComponent
                  type="text"
                  name="val"
                  v-model="opcao.val"
                  placeholder="Valor"
                  placeholderText="Valor"
                  stylized
                  solo
                />
              </div>
              <div class="col-3" v-if="formulario.tipo_campo === 'select-agrupado'">
                <SGPFormInputComponent
                  type="text"
                  name="grupo"
                  v-model="opcao.grupo"
                  placeholder="Grupo"
                  placeholderText="Grupo"
                  stylized
                  solo
                />
              </div>
              <div
                class="col d-flex justify-content-between"
              >
                <div style="margin-top: -10px;">
                  <span class="font-size-14 margin-bottom-8  d-block"><strong>Padrão</strong></span>
                  <v-radio
                    label=""
                    :value="opcao.val"
                    small
                    class=""
                  ></v-radio>
                </div>
                <SGPIconComponent
                  class="mt-5 clickable"
                  icon="mdi-delete"
                  color="red"
                  @click="excluirOpcao(index, opcao)"
                />
              </div>
            </div>
          </v-radio-group>
          <div class="text-center" style="margin-top: 45px; height: 20px">
            <hr style="position: relative" />
            <SGPIconComponent
              style="
                margin-top: -58px;
                margin-bottom: 0;
                padding: 10px;
                border-radius: 25px;
                background-color: #f4f4f4;
              "
              class="clickable"
              icon="mdi-plus-circle"
              color="red"
              @click="adicionarOpcao()"
            />
          </div>
        </div>
      </div>

      <div class="col-12 text-right">
        <div class="container-botoes">
          <SGPFormBotaoComponent color="primary" type="submit">
            {{ tipoFormulario === "salvar" ? "Salvar" : "Atualizar" }}
          </SGPFormBotaoComponent>
          <SGPFormBotaoComponent
            color="grey-3"
            type="button"
            @click="fecharModal()"
          >
            Cancelar
          </SGPFormBotaoComponent>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import criarToast from "@/common/boot/ToastsHandler";
import RequisicaoCampoComponent from './RequisicaoCampoComponent.vue';
export default {
  components: { RequisicaoCampoComponent },
  name: "FormularioCampocomponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: "salvar",
    },
    campo: {
      type: [Object, Boolean],
      required: false,
    }
  },

  data() {
    return {
      tipo_campo: {
        label: "Atributos do campo",
        value: "",
      },
      formulario: this.campo || {
        campo_oculto: false,
        mascara: '',
        opcoes: [],
        requisicao: {}
      },
      classeOpcoes: "",
      possuiValorPadrao: ["text", "number", "textarea", "url"],
      camposTipoData: ["date", "date-time"],
      limite_caractere: this.campo.min || this.campo.max ? true : false,

      mascaras: [
        { label: "RG", value: "##.###.###-##" },
        { label: "CPF", value: "###.###.###-##" },
        { label: "CNPJ", value: "##.###.###/####-##" },
        { label: "Telefone", value: "(##) ####-####" },
        { label: "Celular", value: "(##) #####-####" },
        { label: "Placa Mercosul", value: "AAA XX##"}
      ] 
    }
  },

  created () {
    if (this.tipoFormulario !== 'salvar') {
      this.montaDadosRequisicao()
    }
  },

  computed: {
    // ...mapGetters("ctrlIndicesFichasTecnicas", [
    //   "listaDeIndicesFichasTecnicas",
    //   "loadingIndiceFichaTecnica",
    // ]),

    listaDeIndicesFichasTecnicas() {
      return [];
    },

    listaCamposEdicoes () {
      let lista = null
      if (this.tipoFormulario != 'salvar' && this.campo && this.campo.ctrl_formularios_dinamicos.length) {
          lista = this.options.filter(c => {
           return c.tipo_campo == this.campo.tipo_campo
        })
      }

      return lista
    },

    options () {
      return [
        {
          icon: "mdi-window-minimize",
          label: "Texto curto (Input text)",
          value: "text",
          tipo_campo: "text",
        },
        {
          icon: "mdi-text-box",
          label: "Texto Longo (Textarea)",
          value: "textarea",
          tipo_campo: "textarea",
        },
        {
          icon: "mdi-numeric",
          label: "Número (Input number)",
          value: "number",
          tipo_campo: "number",
        },
        {
          icon: "mdi-link",
          label: "Link (Input text)",
          value: "url",
          tipo_campo: "url",
        },

        {
          icon: "mdi-calendar-range",
          label: "Data (date)",
          value: "date",
          tipo_campo: "date",
        },
        {
          icon: "mdi-clipboard-text-clock-outline",
          label: "Data Hora (date-time)",
          value: "date-time",
          tipo_campo: "date-time",
        },
        {
          icon: "mdi-arrow-down-drop-circle",
          label: "Lista suspensa (Select)",
          value: "select",
          tipo_campo: "select",
        },
        {
          icon: "mdi-radiobox-marked",
          label: "Escolha única (Radio button)",
          value: "radio",
          tipo_campo: "radio",
        },
        {
          icon: "mdi-format-list-group",
          label: "Lista agrupada (Select-agrupado)",
          value: "select-agrupado",
          tipo_campo: "select-agrupado",
        },
        {
          icon: "mdi-list-box",
          label: "Lista dinâmica (sistema)",
          value: "requisicao",
          tipo_campo: "requisicao",
        },
      ]
    },
  },

  methods: {
    ...mapActions("ctrlCampos", ["salvarCampo", "atualizarCampo"]),
    excluirOpcao(index) {
      if (index || this.formulario.opcoes.length > 1) {
        this.formulario.opcoes.splice(index, 1);
        return;
      }

      if (this.formulario.opcoes.length == 1) {
        this.formulario.opcoes = [{
            label: "",
            val: "",
          }];
      }
    },

    adicionarOpcao() {
      const opcao = { label: "", val: "" };
      if (this.formulario.tipo_campo === 'select-agrupado') {
        opcao.grupo = "";
      }
      this.formulario.opcoes.push(opcao);
    },

    handleTipoCampo(tipo_campo) {
      this.tipo_campo = tipo_campo;
      this.formulario.tipo_campo = tipo_campo.tipo_campo;
    },

    selectedOption() {
      if (this.campo) {
        let listaDeTipoCampo = this.options
        .find((c) => (c.value = this.campo.tipo_campo))

        return listaDeTipoCampo
      }

      return null;
    },

    formataMinMax() {
      this.formulario.validacao = "";
      if (this.formulario.min) {
        this.formulario.validacao = `min:${this.formulario.min}|`;
      }

      if (this.formulario.max) {
        this.formulario.validacao = `${this.formulario.validacao}max:${this.formulario.max}`;
      }
    },

    submit() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          const opcoes = this.formulario.opcoes;
          this.classeOpcoes = "";

          this.formataMinMax();

          if (opcoes.length) {
            const itemsVazios = opcoes.filter(
              (o) => o.label == "" || o.val == ""
            );
            if (itemsVazios.length) {
              this.classeOpcoes = "erro";
              criarToast({
                tipo: "error",
                mensagem: "Há campos vazios na listagem de opções!",
              });
              return;
            }
          }

          if (this.tipoFormulario === "salvar") {
            const resp = await this.salvarCampo(this.formulario);
            if (!resp) {
              return;
            }

            this.fecharModal();
            return;
          }

          const resp = await this.atualizarCampo(this.formulario);

          if (!resp) {
            return;
          }
          this.fecharModal();
        }
      });
    },

    fecharModal() {
      this.$emit("fecharModal", true);
    },

    setarMascara(mascara) {
      this.formulario.mascara = mascara;
    },

    montaDadosRequisicao() {
      if (this.campo.tipo_campo === 'requisicao') {
        this.formulario.requisicao = this.campo.ctrl_campo_endpoint
      }
    }
  },

  watch: {
    tipo_campo(val) {
      if (!['select', 'select-agrupado', 'radio'].includes(val.value)) {
        this.formulario.opcoes = [];
        this.formulario.requisicao = {}
      }
    },
  },
};
</script>

<style scoped>
.erro {
  border: solid 1px #f05;
  background-color: rgba(235, 0, 0, 0.08) !important;
}
</style>
